import React from 'react';

const getSeverityColor = (severity) => {
  const colors = {
    INFO: '#4299e1',
    WARNING: '#ed8936',
    ERROR: '#f56565',
    CRITICAL: '#c53030'
  };
  return colors[severity] || colors.INFO;
};

const getSeverityIcon = (severity) => {
  const icons = { INFO: 'ℹ️', WARNING: '⚠️', ERROR: '❌', CRITICAL: '🔴' };
  return icons[severity] || 'ℹ️';
};

const OperationalCard = ({ notification }) => {
  return (
    <div className="operational-card" style={{ borderLeftColor: getSeverityColor(notification.severity) }}>
      <div className="operational-header">
        <div>
          <strong>{notification.title}</strong>
          <span className="operational-category">{notification.category}</span>
        </div>
        <span className="operational-severity" style={{ backgroundColor: getSeverityColor(notification.severity) }}>
          {getSeverityIcon(notification.severity)} {notification.severity}
        </span>
      </div>
      <div className="operational-details">
        <p>{notification.message}</p>
        <p className="operational-timestamp">
          {new Date(notification.timestamp).toLocaleString('it-IT')}
        </p>
      </div>
    </div>
  );
};

export default OperationalCard;
